import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const DeliveryRoute = [
    {
        path: '/delivery',
        component: React.lazy(() => import('./Delivery.js')),
        auth: AuthRoles.editor,
    }
]

export default DeliveryRoute;